import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
import * as React from 'react'

const styles = require('./styles.scss')

export interface Props {
  handleSeeMoreOffers: () => void
}

const SeeAllOffersButton: React.SFC<Props> = ({ handleSeeMoreOffers }) => (
  <ThemeConsumer>
    {({ colorPrimary, colorTextPrimary }) => (
      <span
        className={classnames(
          styles.seeMore,
          css`
            a {
              color: ${colorPrimary};
              &:hover {
                color: ${colorTextPrimary};
              }
            }
          `,
        )}
      >
        <a onClick={handleSeeMoreOffers}>See All Offers</a>
      </span>
    )}
  </ThemeConsumer>
)

export default SeeAllOffersButton
